import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { RuntimePolicySurface } from '../../../generated/api/types.gen.js';
import { usePolicy } from '../../../hooks/usePolicy.js';
import { runtimePolicyApi } from '../../../services/api/runtime-policy.api.js';
import { Card } from '../../../components/ui/index.js';
import { RuntimePolicyAssigner } from '../../../components/ui/RuntimePolicyAssigner.js';
import type { EmployeeView } from '../shared';

interface EmployeePolicyCardProps {
  employee: EmployeeView;
}

/** The runtime policy an employee runs under; a workforce manager can change it. */
export const EmployeePolicyCard: React.FC<EmployeePolicyCardProps> = ({ employee }) => {
  const queryClient = useQueryClient();
  const canManage = usePolicy('CanManageWorkforce');
  const policyId = employee.raw.runtimePolicyId;
  const employeeId = Number(employee.id);
  if (typeof policyId !== 'number' || !Number.isSafeInteger(employeeId)) return null;
  return (
    <Card>
      <RuntimePolicyAssigner
        surface={RuntimePolicySurface.WORKFORCE}
        label={employee.name}
        currentPolicyId={policyId}
        canChange={canManage}
        onAssign={async (id) => {
          await runtimePolicyApi.setEmployeePolicy(employeeId, id);
          // The workforce hooks key every employee query under the 'workforce' root.
          await queryClient.invalidateQueries({ predicate: (query) => query.queryKey[0] === 'workforce' });
        }}
      />
    </Card>
  );
};
